import LoadingScreen from '@/components/common/LoadingScreen'
import AuthProvider from '@/features/auth/provider'
import CopilotWidget from '@/features/copilot/CopilotWidget'
import { useTranslation } from '@/hooks/useTranslation'
import { SignalRProvider } from '@/signalr/context'
import store from '@/store/stores'
import { ThemeProvider } from '@/theme'
import { CssBaseline, StyledEngineProvider } from '@mui/material'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense, useEffect, useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import AppRoute from './AppRoute'
import { ErrorBoundary } from './ErrorBoundary'
import { GlobalHoverSidebar } from '@/components/layout/GlobalHoverSidebar'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      // 🎉 only show error toasts if we already have data in the cache
      // which indicates a failed background update
      // if (error?.response?.status === 401) {
      //   localStorage.clear()
      //   window.location.href = '/'
      // }
    },
  }),
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
  },
})

function LanguageAttributeManager() {
  const { currentLanguage } = useTranslation()

  useEffect(() => {
    document.documentElement.setAttribute('data-lang', currentLanguage)
  }, [currentLanguage])

  return null
}

function App() {
  const [isFirstApp, setIsFirstApp] = useState(false)

  useEffect(() => {
    createKeyMap()
  }, [])

  const createKeyMap = () => {
    setTimeout(() => {
      setIsFirstApp(true)
    }, 2000)
  }
  if (!isFirstApp) return <LoadingScreen />

  return (
    <Provider store={store}>
      <ThemeProvider>
        <ErrorBoundary>
          <SignalRProvider>
            <StyledEngineProvider injectFirst>
              <Suspense fallback={<LoadingScreen />}>
                <CssBaseline />
                <QueryClientProvider client={queryClient}>
                  <AuthProvider>
                    <LanguageAttributeManager />
                    <GlobalHoverSidebar>
                      <AppRoute />
                    </GlobalHoverSidebar>
                    <CopilotWidget />
                  </AuthProvider>
                  {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                </QueryClientProvider>
              </Suspense>
            </StyledEngineProvider>
          </SignalRProvider>
          <Toaster position="top-right" reverseOrder={false} />
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  )
}

export default App
